import React from "react";

export default function HotOffers() {
  return (
    <section className="gauto-offers-area section_70">
      <div className="container">

        {/* Section Heading */}
        <div className="row">
          <div className="col-md-12">
            <div className="site-heading">
              <h4>Come with</h4>
              <h2>Hot Offers</h2>
            </div>
          </div>
        </div>

        {/* 6 Cars Only */}
        <div className="row">

          <OfferCard
            img="/images/fleets/amaze.png"
            title="Swift Desire"
            price="₹13 / Km"
          />

          <OfferCard
            img="/images/fleets/honda-city.png"
            title="Honda City"
            price="₹13 / Km"
          />

          <OfferCard
            img="/images/fleets/ertiga.png"
            title="Maruti Ertiga"
            price="₹15 / Km"
          />

          <OfferCard
            img="/images/fleets/innova-crysta.png"
            title="Toyota Innova"
            price="₹18 / Km"
          />

          <OfferCard
            img="/images/fleets/innova.png"
            title="Innova Crysta"
            price="₹21 / Km"
          />

          <OfferCard
            img="/images/fleets/kia.png"
            title="Kia Carens"
            price="₹16 / Km"
          />

        </div>

      </div>
    </section>
  );
}

/* ==== OFFER CARD COMPONENT ==== */
const OfferCard = ({ img, title, price }) => (
  <div className="col-lg-4 col-md-6">
    <div className="single-offers">

      <div className="offer-image">
        <img src={img} alt={title} />
      </div>

      <div className="offer-text">
        <h3>{title}</h3>
        <h4>{price}</h4>

        <ul>
          <li><i className="fa fa-car"></i> AC Cab</li>
          <li><i className="fa fa-user"></i> Professional Driver</li>
          <li><i className="fa fa-map-marker"></i> Outstation / Local</li>
        </ul>

        <div className="offer-action">
          <a href="/booking" className="offer-btn-1">Book Now</a>
          <a href="/our-fleet" className="offer-btn-2">Details</a>
        </div>
      </div>

    </div>
  </div>
);
